export const isCordova = () => {
  return !!window.cordova;
};